const API_SUFFIX = "/api";

export function normalizeApiBaseUrl(baseUrl: string): string {
  const trimmed = baseUrl.trim().replace(/\/+$/, "");

  if (!trimmed) {
    return "";
  }

  return trimmed.endsWith(API_SUFFIX) ? trimmed : `${trimmed}${API_SUFFIX}`;
}

export function getApiOrigin(baseUrl: string): string {
  const normalized = normalizeApiBaseUrl(baseUrl);

  return normalized.endsWith(API_SUFFIX)
    ? normalized.slice(0, -API_SUFFIX.length)
    : normalized;
}

export function buildAdRequestUrl(baseUrl: string, placementId: string): string {
  return `${normalizeApiBaseUrl(baseUrl)}/v1/ad-requests/request/${encodeURIComponent(
    placementId,
  )}`;
}

export function buildBatchAdRequestUrl(baseUrl: string): string {
  return `${normalizeApiBaseUrl(baseUrl)}/v1/ad-requests/request/batch`;
}

export function resolveAgainstApiOrigin(
  baseUrl: string,
  value: string | undefined,
): string | undefined {
  const trimmed = value?.trim();

  if (!trimmed) {
    return undefined;
  }

  return new URL(trimmed, `${getApiOrigin(baseUrl).replace(/\/+$/, "")}/`)
    .href;
}
